namespace advisorop.components.servicer {

    export class AdobesignIntegrationResponseController {
        $router;

        responseMessage: string = "...Please Wait...";
        showCloseButton: boolean = false;

        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {
        }

        closeWindow(): void {
            window.close();
        }

        adobeSignLinkResponse(): void {
            var urlComponents = this.getJsonFromUrl(location.href);

            // all 4 expected components from adobe sign need to be sent back
            if (urlComponents['code'] == undefined
                || urlComponents['api_access_point'] == undefined
                || urlComponents['web_access_point'] == undefined
                || urlComponents['state'] == undefined) {
                this.responseMessage = "Adobe Sign did not send back the expected set of details. Unable to link. Please contact AdvisorOp Support.";
                toastr.error(this.responseMessage);
            } else {
                this.servicerService.adobesignIntegrationResponse(urlComponents['code'],
                    urlComponents['api_access_point'],
                    urlComponents['web_access_point'],
                    urlComponents['state'])
                    .then(data => {
                        this.responseMessage = "Your account has been successfully linked to Adobe Sign.";
                        toastr.success(this.responseMessage);
                    })
                    .catch(err => {
                        this.responseMessage = "Error linking your account to Adobe Sign, please contact AdvisorOp Support.";
                        toastr.success(this.responseMessage);
                    }).finally(() => { this.showCloseButton = true; });
            }
        }

        $onInit(): void {
            this.adobeSignLinkResponse();
        }

        $routerOnActivate(next, previous) {

        }

        getJsonFromUrl(url: string): {} {
            var url = location.href;
            var question = url.indexOf("?");
            var hash = url.indexOf("#");
            if (hash == -1 && question == -1) return {};
            if (hash == -1) hash = url.length;
            var query = question == -1 || hash == question + 1 ? url.substring(hash) :
                url.substring(question + 1, hash);
            var result = {};
            query.split("&").forEach(function (part) {
                if (!part) return;
                part = part.split("+").join(" "); // replace every + with space, regexp-free version
                var eq = part.indexOf("=");
                var key = eq > -1 ? part.substr(0, eq) : part;
                var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
                var from = key.indexOf("[");
                if (from == -1) result[decodeURIComponent(key)] = val;
                else {
                    var to = key.indexOf("]", from);
                    var index = decodeURIComponent(key.substring(from + 1, to));
                    key = decodeURIComponent(key.substring(0, from));
                    if (!result[key]) result[key] = [];
                    if (!index) result[key].push(val);
                    else result[key][index] = val;
                }
            });
            return result;
        }
    }

    class AdobesignIntegrationResponse implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                $router: '<'
            };
            this.controller = AdobesignIntegrationResponseController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/adobesign-integration-response.html';
        }

    }
    angular.module(Constants.APP).component("adobesignIntegrationResponse", new AdobesignIntegrationResponse());
}
